import { render, staticRenderFns } from "./CardEbook.vue?vue&type=template&id=5d818e5f"
import script from "./CardEbook.vue?vue&type=script&lang=js"
export * from "./CardEbook.vue?vue&type=script&lang=js"
import style0 from "./CardEbook.vue?vue&type=style&index=0&id=5d818e5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports